<nz-layout>
  @if (!shell.fullPage || shell.fullPageAuth) {
  <nz-header class="legacy-shell__header">
    <div class="legacy-shell__header-inner">
      @if (shell.isLoading) {
      <nz-skeleton [nzActive]="true" [nzAvatar]="{ size: 'small', shape: 'circle' }" [nzTitle]="false"
        [nzParagraph]="false"></nz-skeleton>
      } @else if (!shell.fullPage) {
      <div class="legacy-shell__header-bar">
        <nz-icon class="trigger legacy-shell__menu-trigger" nzType="menu" (click)="shell.toggleMenu()"></nz-icon>
        @if (!shell.isMobile()) {
        <button
          type="button"
          nz-button
          nzType="text"
          class="legacy-shell__sider-trigger-btn legacy-shell__header-collapse-btn"
          nz-tooltip
          [nzTooltipTitle]="shell.isCollapsed() ? 'Expandir menu' : 'Recolher menu'"
          [attr.aria-label]="shell.isCollapsed() ? 'Expandir menu' : 'Recolher menu'"
          (click)="shell.toggleSiderCollapse()">
          <nz-icon [nzType]="shell.isCollapsed() ? 'menu-unfold' : 'menu-fold'"></nz-icon>
        </button>
        }
        <div class="legacy-shell__header-actions">
          @if (showTryNewLayout) {
          <div class="legacy-shell__try-layout-wrap">
            <button
              nz-button
              nzType="default"
              nzSize="small"
              class="legacy-shell__try-layout"
              nz-tooltip
              nzTooltipTitle="Teste a nova navegação e interface (beta). Você pode voltar em Configurações."
              (click)="tryNewLayout()">
              <span nz-icon nzType="experiment"></span>
              <span class="legacy-shell__try-layout-label">Experimentar novo layout</span>
            </button>
            <nz-tag class="legacy-shell__try-layout-tag">Beta</nz-tag>
          </div>
          }
          <button nz-button nzType="text" class="legacy-shell__logout" (click)="shell.logout()">
            <span>Sair</span> <nz-icon nzType="logout"></nz-icon>
          </button>
        </div>
      </div>
      }
    </div>
  </nz-header>
  }

  <nz-layout class="legacy-shell__body">
    <ng-template #affixMenu>
      @if (shell.isLoading) {
      <div style="padding: 12px;">
        @for (_ of [0,1,2,3,4,5,6,7]; track $index) {
        <div style="margin-bottom: 12px;">
          <nz-skeleton [nzActive]="true" [nzTitle]="{ width: '60%' }" [nzParagraph]="false"></nz-skeleton>
        </div>
        }
      </div>
      } @else {
      <ul nz-menu nzMode="inline" class="sider-menu" [nzInlineCollapsed]="shell.isCollapsed() && !shell.isMobile()">
        @for (item of visibleLegacyRoutes; track item.label) {
        @if (shell.canShow(item)) {
        @if (!item.children) {
        <li nz-menu-item [routerLink]="item.link" routerLinkActive="ant-menu-item-selected">
          @if (item.icon) { <span nz-icon [nzType]="item.icon"></span> }
          <span>{{ item.label }}</span>
        </li>
        } @else {
        <li
          nz-submenu
          [nzTitle]="item.label"
          [nzIcon]="item.icon || ''"
          [nzOpen]="isSubmenuOpen(item.label)"
          (nzOpenChange)="onSubmenuOpenChange(item.label, $event)">
          <ul>
            @for (child of item.children; track child.label) {
            @if (shell.canShow(child)) {
            <li
              nz-menu-item
              [routerLink]="child.link"
              routerLinkActive="ant-menu-item-selected"
              [routerLinkActiveOptions]="{ exact: child.exactActive ?? false }">
              @if (child.icon) { <span nz-icon [nzType]="child.icon"></span> }
              <span>{{ child.label }}</span>
            </li>
            }
            }
          </ul>
        </li>
        }
        }
        }
      </ul>
      }
    </ng-template>
    @if (!shell.fullPage) {
    @if (!shell.isMobile()) {
    <nz-sider
      #sider
      nzCollapsible
      [nzTrigger]="null"
      [nzCollapsed]="shell.isCollapsed()"
      [nzCollapsedWidth]="80"
      nzWidth="20vw"
      nzTheme="light"
      class="legacy-shell__sider"
      (nzCollapsedChange)="onSiderCollapseChange($event)">
      <div class="legacy-shell__sider-inner">
        <ng-container *ngTemplateOutlet="affixMenu"></ng-container>
      </div>
      <div class="legacy-shell__sider-trigger">
        <button
          type="button"
          nz-button
          nzType="text"
          class="legacy-shell__sider-trigger-btn"
          [attr.aria-label]="shell.isCollapsed() ? 'Expandir menu' : 'Recolher menu'"
          (click)="shell.toggleSiderCollapse()">
          <nz-icon [nzType]="shell.isCollapsed() ? 'menu-unfold' : 'menu-fold'"></nz-icon>
        </button>
      </div>
    </nz-sider>
    }

    <nz-drawer
      [nzVisible]="shell.drawerVisible"
      nzPlacement="left"
      nzClosable="true"
      [nzBodyStyle]="{ padding: '0' }"
      (nzOnClose)="shell.drawerVisible = false">
      <ng-container *nzDrawerContent>
        <ng-container *ngTemplateOutlet="affixMenu"></ng-container>
      </ng-container>
    </nz-drawer>
    }

    <nz-layout
      class="inner-layout"
      [class.inner-layout--full-page]="shell.fullPage"
      [class.inner-layout--full-page-auth]="shell.fullPageAuth">
      <nz-content>
        @if (shell.isLoading) {
        <div nz-row nzJustify="center" class="logo">
          <div nz-col nzSpan="4" style="text-align:center; padding: 12px 0;">
            <nz-skeleton [nzActive]="true" [nzAvatar]="{ shape: 'square', size: 64 }" [nzTitle]="false"
              [nzParagraph]="false"></nz-skeleton>
          </div>
        </div>
        <div style="margin: 8px 0 16px 0;">
          <nz-skeleton [nzActive]="true" [nzTitle]="{ width: '30%' }" [nzParagraph]="false"></nz-skeleton>
        </div>
        <div class="inner-content">
          <nz-skeleton [nzActive]="true" [nzTitle]="{ width: '40%' }" [nzParagraph]="{ rows: 6 }"></nz-skeleton>
        </div>
        } @else {
        @if (!shell.fullPage) {
        <div nz-row nzJustify="center" class="logo">
          <div nz-col nzSpan="4">
            <img [src]="shell.associacaoLogo" alt="Logo">
          </div>
        </div>
        }
        <div
          class="inner-content"
          [class.inner-content--full-page]="shell.fullPage"
          [class.inner-content--full-page-auth]="shell.fullPageAuth">
          <router-outlet></router-outlet>
        </div>
        }
      </nz-content>
      @if (!shell.fullPage || shell.fullPageAuth) {
      <nz-footer>
        <div style="display:flex;justify-content:space-between;align-items:center;">
          <div>Plataforma Veitros ©{{ shell.date.getFullYear() }} - Todos os direitos reservados.</div>
          <div style="opacity:0.85;font-size:0.9rem;">Versão: {{ shell.appVersion || '—' }}</div>
        </div>
      </nz-footer>
      }
    </nz-layout>
  </nz-layout>
</nz-layout>
